import { action } from "typesafe-actions";
import { TransactionActionTypes } from "./transaction.model";

export const fetchPricesRequest = (req) => action(TransactionActionTypes.FETCH_PRICES_REQUEST, req);
export const fetchPricesSuccess = (res) => action(TransactionActionTypes.FETCH_PRICES_SUCCESS, res);
export const fetchPricesFailure = (err) => action(TransactionActionTypes.FETCH_PRICES_FAILURE, err);


